import Resizer from '@prismamedia/image-resizer-client';

export const resizer = new Resizer({
  protocol: 'https', // 'http', 'https', false (false means "protocol-relative")
  domain: config.RESIZER_DOMAIN,
  defaultParameters: { quality: 80 },
  defaultFormat: 'jpg', // 'jpg', 'gif', 'png'
});

export const resizeURL = (
  origin?: string | null,
  format?: 'jpg' | 'gif' | 'png',
) => {
  if (!origin) {
    return;
  }
  return resizer.fit({
    origin,
    format,
    width: 350,
    height: 150,
  });
};
